var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadlessui = function SvgHeadlessui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.871%",
    y1: "7.224%",
    x2: "60.314%",
    y2: "115.988%",
    id: "headlessui_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66E3FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7064F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.172%",
    y1: "0%",
    x2: "55.05%",
    y2: "99.181%",
    id: "headlessui_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66E3FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7064F9",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.699 159.089 156.225-52.153c-3.122-19.523-5.346-32.565-7.924-42.518-2.777-10.706-4.978-13.57-5.842-14.563a30.468 30.468 0 0 0-10.973-7.969c-1.216-.52-4.625-1.728-15.654-1.064-11.669.704-26.987 3.088-51.245 6.929-24.25 3.84-39.56 6.313-50.87 9.241-10.7 2.777-13.573 4.985-14.566 5.85a30.581 30.581 0 0 0-7.963 10.97c-.52 1.215-1.729 4.624-1.064 15.658.704 11.665 3.089 26.988 6.93 51.24 1.073 6.8 2.041 12.882 2.946 18.379Z",
    fill: "url(#headlessui_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 147.063c-7.427-46.92-11.149-70.38-3.098-89.214a71.092 71.092 0 0 1 18.6-25.605c15.423-13.466 38.88-17.178 85.796-24.611C155.854.19 179.313-3.521 198.16 4.528a71.085 71.085 0 0 1 25.595 18.595c13.477 15.426 17.19 38.886 24.618 85.814 7.435 46.92 11.149 70.387 3.097 89.214a71.076 71.076 0 0 1-18.591 25.604c-15.423 13.474-38.889 17.187-85.812 24.62-46.916 7.433-70.382 11.146-89.213 3.096a71.093 71.093 0 0 1-25.595-18.595C18.781 217.45 15.068 193.99 7.633 147.063h-.008Zm82.762 83.325c12.565-.76 28.748-3.296 52.702-7.09 23.962-3.792 40.12-6.384 52.318-9.545 11.805-3.064 17.247-6.049 20.76-9.121a45.696 45.696 0 0 0 11.95-16.459c1.84-4.288 3-10.385 2.264-22.563-.76-12.562-3.297-28.749-7.09-52.705-3.794-23.955-6.38-40.126-9.54-52.312-3.066-11.81-6.059-17.25-9.124-20.763a45.699 45.699 0 0 0-16.455-11.954c-4.29-1.84-10.388-3-22.57-2.265-12.565.76-28.74 3.297-52.701 7.09-23.954 3.8-40.121 6.385-52.31 9.545-11.813 3.065-17.247 6.057-20.76 9.122a45.704 45.704 0 0 0-11.958 16.458c-1.833 4.289-2.993 10.386-2.257 22.564.76 12.57 3.29 28.748 7.091 52.704 3.794 23.956 6.379 40.127 9.54 52.313 3.065 11.81 6.05 17.25 9.124 20.763a45.707 45.707 0 0 0 16.455 11.954c4.29 1.84 10.38 3 22.57 2.264h-.009Z",
    fill: "url(#headlessui_svg__b)"
  })));
};
export default SvgHeadlessui;